import { render, staticRenderFns } from "./uploadDocuments.vue?vue&type=template&id=ef70c1a0&scoped=true&"
import script from "./uploadDocuments.vue?vue&type=script&lang=js&"
export * from "./uploadDocuments.vue?vue&type=script&lang=js&"
import style0 from "./uploadDocuments.vue?vue&type=style&index=0&id=ef70c1a0&lang=less&scoped=true&"
import style1 from "./uploadDocuments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef70c1a0",
  null
  
)

export default component.exports